// src/features/clean/cleanSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import cleanService from "./cleanService";

// Async thunk untuk fetch data dari /cleans
export const fetchCleans = createAsyncThunk("cleans/fetchCleans", async () => {
  const data = await cleanService.getCleans();
  return data;
});

const cleanSlice = createSlice({
  name: "cleans",
  initialState: {
    cleansList: [],
    status: "idle", // idle | loading | succeeded | failed
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCleans.pending, (state) => {
        state.loading = true;
        state.status = "loading";
      })
      .addCase(fetchCleans.fulfilled, (state, action) => {
        state.loading = false;
        state.status = "succeeded";
        state.cleansList = action.payload;
      })
      .addCase(fetchCleans.rejected, (state, action) => {
        state.loading = false;
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export default cleanSlice.reducer;
